
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/developer/changelog",
      function () {
        return require("private-next-pages/developer/changelog.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/developer/changelog"])
      });
    }
  